import { LANGUAGES } from './constants';
import moment from 'moment';

const browserLanguage = navigator.language.split('-')[0];
const language = LANGUAGES.includes(browserLanguage) ? browserLanguage : 'en';

export default moment.locale(language);
